import BaseModel from './BaseModel'
import ModelArray from './ModelArray';
import TransactionItem from './TransactionItem'
import VistaDate from './VistaDate';
import MovieService from '../service/movie-service';
export default class Transaction extends BaseModel {

    constructor(data = undefined) {
        super(data);
        this.CinemaId = data.CinemaId;
        this.CinemaName = data.CinemaName;
        this.MovieId = data.MovieId;
        this.MovieName = data.MovieName;
        this.ItemName = data.ItemName;
        // this.PointsEarned = data.PointsEarned;
        // this.PointsRedeemed = data.PointsRedeemed;
        this.SessionTime = data.SessionTime ? new VistaDate(data.SessionTime) : null;
        this.TransactionDate = data.TransactionDate ? new VistaDate(data.TransactionDate) : null;
        this.TransactionId = data.TransactionId;
        this.VistaTransactionId = data.VistaTransactionId;
        this.Items = new ModelArray(data.Items, TransactionItem);
    }

    get PointsEarned(){
        return this.Items ? this.Items.reduce((t,i)=>t = t +  i.PointsEarned,0) : 0;
    }
    get PointsRedeemed(){
        return this.Items ? this.Items.reduce((t,i)=>t = t + i.PointsRedeemed,0) : 0;
    }

    get year(){
        return this.TransactionDate ? this.TransactionDate.additional.year : null;
    }


    get month(){
        return this.TransactionDate ? this.TransactionDate.additional.string_long_month : null;
    }



}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/Transaction.js